<div class="d-flex align-items-center">
    <p-select [options]="columnList" optionLabel="name" optionValue="id" name="selectedList"
        [(ngModel)]="selectedList" [style]="{height:'32px'}"  (onChange)="handleUpdateColumnFilterChange($event)">
        <ng-template let-preference pTemplate="item">
            <div class="flex align-items-center">
                <div>{{ preference.name }}</div>
            </div>
        </ng-template>
    </p-select>
   
    <img [src]="'assets/image/Arrange.svg'" (click)="showColumnSetting = !showColumnSetting" alt="Arrange"
          style="margin-left: 3px;" />

</div>


@if(showColumnSetting) {
    <p-dialog [(visible)]="showColumnSetting" [draggable]="false" [modal]="true"
    [style]="{ width: '40%', 'height': '70vh'}">
    <ng-template #header class="dialogHeader">
        Update Column Preference
    </ng-template>
    <div class="px-3 py-2">
        <app-column-settings 
        (OnListUpdation)="OnListUpdation($event)"
        [sourceColumnList]="sourceColumnList" [targetColumnList]="targetColumnList" ></app-column-settings>
    </div>
    <ng-template #footer>
        <div class="d-flex justify-content-center">
          <button (click)="updateColumnConfiguration()" class="pn-button pn-button-primary pn-button-md me-1" type="button">
            <span>Update</span>
          </button>
          <button (click)="showColumnSetting = !showColumnSetting" class="pn-button pn-button-tertiary pn-button-md">Cancel</button>
        </div>
    </ng-template >
</p-dialog>
}